module.exports = __webpack_public_path__ + "img/arrows-maximize.7af8762b.svg";